var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 1.1686V1.16675H11.6654C11.9883 1.16675 12.25 1.43235 12.25 1.7453V12.2549C12.25 12.5744 11.9905 12.8334 11.6705 12.8334H2.32948C2.00944 12.8334 1.75 12.571 1.75 12.2461V4.66675L5.25 1.1686ZM3.40035 4.66675H5.25V2.81808L3.40035 4.66675ZM6.41667 2.33341V5.25008C6.41667 5.57225 6.15551 5.83342 5.83333 5.83342H2.91667V11.6667H11.0833V2.33341H6.41667Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.36a5cce1260928cfbf9523a4bb6b008c.svg";
export { ForwardRef as ReactComponent };